import { useEffect } from "react";
import Canvas from "../components/Canvas/index";
import { useRef } from "react";

export default function CanvasPage() {
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Add a keydown handler for the Enter key
  useEffect(() => {
    const handleKeyDown = (event: Event) => {
      // Cast the event to KeyboardEvent
      const keyEvent = event as KeyboardEvent;
      
      if (keyEvent.key === 'Enter') {
        
        // Check if we're not in any input field
        const isInFormField =
          keyEvent.target instanceof HTMLInputElement ||
          keyEvent.target instanceof HTMLTextAreaElement ||
          (keyEvent.target instanceof HTMLElement && keyEvent.target.isContentEditable);
        
        // Check if we're on the canvas page and no dialogs are open
        const noDialogsOpen = !document.querySelector('.dialog-open') && !document.querySelector('.menu-open');
        
        // Only trigger search focus when no dialogs are open and not in a form field
        if (!isInFormField && noDialogsOpen) {
          // Find the search input and focus it
          const searchInput = document.querySelector('.search-input') as HTMLInputElement;
          if (searchInput) {
            searchInput.focus();
            
            // Prevent default behavior
            keyEvent.preventDefault();
            keyEvent.stopPropagation();
          } else {
          }
        }
      }
    };
    
    // Add the event listener to the container element if it exists, otherwise to the window
    const targetElement = containerRef.current || window;
    targetElement.addEventListener('keydown', handleKeyDown);
    
    // Remove the event listener on cleanup
    return () => {
      targetElement.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="w-full" ref={containerRef} tabIndex={0}>
      <Canvas isEmbedded={Boolean()} />
    </div>
  );
}
